import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CenterLoader } from '@im/ui-lib/CenterLoader';

import { useOktaAuth } from '@okta/okta-react';
import { useBuildVars, useSiteConfig } from '../config';

const ORIGIN = globalThis.location.origin;

export const LogoutView = () => {
  const oktaContext = useOktaAuth();
  const navigate = useNavigate();
  const siteConfig = useSiteConfig();
  const { appId = 'cep' } = useBuildVars();

  const logoutRedirectUri = siteConfig.idpLogin
    ? `/${appId}`
    : `/${appId}/app/login`;

  useEffect(() => {
    const oktaAuth = oktaContext?.oktaAuth;
    const postLogoutRedirectUri = `${ORIGIN}${logoutRedirectUri}`;

    if (oktaAuth) {
      localStorage.removeItem('OktaSession');
      localStorage.removeItem('AccessToken');
      localStorage.removeItem('WarehouseStore');
      sessionStorage.removeItem('trendingProductsFilters');
      localStorage.removeItem('visitedQuickInsightPages');
      sessionStorage.removeItem('ignoreCCRedirect');
      localStorage.removeItem('getContact');
      oktaAuth
        .signOut({ postLogoutRedirectUri })
        .then(() => {
          oktaAuth.tokenManager.clear();
        })
        .catch((err) => {
          console.error('Sign out error:', err);
        });
    } else {
      window.location.href = postLogoutRedirectUri;
    }
  }, [navigate, oktaContext, logoutRedirectUri]);

  return <CenterLoader />;
};
